export const socketKinds = {
  ChatMessageReceived: 'ChatMessageReceived',
  ChatStatusUpdate: 'ChatStatusUpdate',
  ChatOwnershipChanged: 'ChatOwnershipChanged',
  ReviewReceived: 'ReviewReceived',
  ChatTyping: 'ChatTyping',
  ChatPendingMessageCountChanged: 'ChatPendingMessageCountChanged',
  PendingBookingCountChanged: 'PendingBookingCountChanged',
  GdsChatCountChanged: 'GdsChatCountChanged',
  PendingBooking: 'PendingBooking'
}

export const socketHubs = {
  Service: 'Service',
  Sales: 'Sales',
  Review: 'Review',
  Direct: 'Direct'
}
